import { render } from "./Registro.vue?vue&type=template&id=4488e549&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"

import "./Registro.vue?vue&type=style&index=0&id=4488e549&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4488e549"]])

export default __exports__